window.dataLayer = window.dataLayer || [];

function shopifySafeNumber(value) {
  var n = Number(value);
  return isNaN(n) ? 0 : n;
}

function buildNativeItemId(productData) {
  if (productData.item_id) return productData.item_id;

  if (productData.shop_domain && productData.product_id && productData.variant_id) {
    return 'shopify_' + productData.shop_domain + '_' + productData.product_id + '_' + productData.variant_id;
  }

  return productData.variant_id || productData.product_id || null;
}

function buildLegacyItemId(productData) {
  if (productData.legacy_item_id) return productData.legacy_item_id;

  if (productData.product_id && productData.variant_id) {
    return 'shopify_ZZ_' + productData.product_id + '_' + productData.variant_id;
  }

  return productData.variant_id || productData.product_id || null;
}

function buildItem(productData) {
  return {
    item_id: buildNativeItemId(productData),
    item_name: productData.item_name || null,
    item_brand: productData.item_brand || null,
    item_category: productData.item_category || null,
    item_variant: productData.item_variant || null,
    price: shopifySafeNumber(productData.price),
    quantity: shopifySafeNumber(productData.quantity || 1)
  };
}

function buildEventModelItem(productData) {
  return {
    id: buildLegacyItemId(productData),
    name: productData.item_name || null,
    brand: productData.item_brand || null,
    category: productData.item_category || null,
    price: shopifySafeNumber(productData.price),
    variant: productData.item_variant || null
  };
}

function buildUserData(productData) {
  return {
    email: productData.email || null,
    phone_number: productData.phone_number || null,
    address: {
      first_name: productData.first_name || null,
      last_name: productData.last_name || null,
      street: productData.street || null,
      city: productData.city || null,
      region: productData.region || null,
      postal_code: productData.postal_code || null,
      country: productData.country || null
    }
  };
}

function mapCheckoutItems(lines) {
  return (lines || []).map(function(line) {
    var itemData = {
      product_id: line.product_id || null,
      variant_id: line.variant_id || null,
      item_name: line.item_name || null,
      item_brand: line.item_brand || null,
      item_category: line.item_category || null,
      item_variant: line.item_variant || null,
      price: line.price || 0,
      quantity: line.quantity || 1
    };

    var eventModelItem = buildEventModelItem(itemData);
    return {
      id: eventModelItem.id,
      name: eventModelItem.name,
      brand: eventModelItem.brand,
      category: eventModelItem.category,
      price: eventModelItem.price,
      quantity: shopifySafeNumber(itemData.quantity),
      variant: eventModelItem.variant
    };
  });
}

function pushViewItem(productData) {
  var item = buildItem(productData);
  var eventModelItem = buildEventModelItem(productData);
  var userData = buildUserData(productData);

  window.dataLayer.push({
    event: 'view_item',
    page_type: 'product',
    ecommerce: {
      currency: productData.currency || null,
      value: shopifySafeNumber(productData.price),
      items: [item]
    },
    eventModel: {
      ecomm_prodid: eventModelItem.id ? [eventModelItem.id] : [],
      ecomm_totalvalue: shopifySafeNumber(productData.price),
      ecomm_pagetype: 'product',
      currency: productData.currency || null,
      value: shopifySafeNumber(productData.price),
      items: [eventModelItem],
      user_data: userData
    }
  });
}

function pushAddToCart(productData) {
  var quantity = shopifySafeNumber(productData.quantity || 1);
  var unitPrice = shopifySafeNumber(productData.price);
  var item = buildItem(productData);
  var eventModelItem = buildEventModelItem(productData);
  var userData = buildUserData(productData);

  window.dataLayer.push({
    event: 'add_to_cart',
    page_type: 'cart',
    ecommerce: {
      currency: productData.currency || null,
      value: unitPrice * quantity,
      items: [item]
    },
    eventModel: {
      ecomm_prodid: eventModelItem.id ? [eventModelItem.id] : [],
      ecomm_totalvalue: unitPrice * quantity,
      ecomm_pagetype: 'cart',
      currency: productData.currency || null,
      value: unitPrice * quantity,
      items: [eventModelItem],
      user_data: userData
    }
  });
}

function pushRemoveFromCart(productData) {
  var quantity = shopifySafeNumber(productData.quantity || 1);
  var unitPrice = shopifySafeNumber(productData.price);
  var item = buildItem(productData);
  var eventModelItem = buildEventModelItem(productData);
  var userData = buildUserData(productData);

  window.dataLayer.push({
    event: 'remove_from_cart',
    page_type: 'cart',
    ecommerce: {
      currency: productData.currency || null,
      value: unitPrice * quantity,
      items: [item]
    },
    eventModel: {
      ecomm_prodid: eventModelItem.id ? [eventModelItem.id] : [],
      ecomm_totalvalue: unitPrice * quantity,
      ecomm_pagetype: 'cart',
      currency: productData.currency || null,
      value: unitPrice * quantity,
      items: [eventModelItem],
      user_data: userData
    }
  });
}

function pushViewItemList(listData) {
  var userData = buildUserData(listData);

  var ecommerceItems = (listData.items || []).map(function(productData, index) {
    var item = buildItem(productData);
    item.index = productData.index || (index + 1);
    item.item_list_name = listData.item_list_name || null;
    return item;
  });

  var eventModelItems = (listData.items || []).map(function(productData, index) {
    var item = buildEventModelItem(productData);
    item.index = productData.index || (index + 1);
    item.item_list_name = listData.item_list_name || null;
    return item;
  });

  window.dataLayer.push({
    event: 'view_item_list',
    page_type: 'collection',
    ecommerce: {
      item_list_name: listData.item_list_name || null,
      currency: listData.currency || null,
      items: ecommerceItems
    },
    eventModel: {
      ecomm_prodid: eventModelItems.map(function(item) { return item.id; }).filter(Boolean),
      ecomm_totalvalue: eventModelItems.reduce(function(sum, item) {
        return sum + shopifySafeNumber(item.price);
      }, 0),
      ecomm_pagetype: 'category',
      item_list_name: listData.item_list_name || null,
      currency: listData.currency || null,
      items: eventModelItems,
      user_data: userData
    }
  });
}

function pushBeginCheckout(payload) {
  var userData = buildUserData(payload);

  window.dataLayer.push({
    event: 'begin_checkout',
    eventModel: {
      ecomm_prodid: (payload.items || []).map(function(item) { return item.id; }).filter(Boolean),
      ecomm_totalvalue: shopifySafeNumber(payload.value),
      ecomm_pagetype: 'cart',
      value: shopifySafeNumber(payload.value),
      currency: payload.currency || null,
      items: payload.items || [],
      user_data: userData
    }
  });
}

function pushPurchase(payload) {
  var userData = buildUserData(payload);

  window.dataLayer.push({
    event: 'purchase',
    eventModel: {
      transaction_id: payload.transaction_id || null,
      new_customer: payload.new_customer,
      customer_type: payload.customer_type,
      value: shopifySafeNumber(payload.value),
      currency: payload.currency || null,
      tax: shopifySafeNumber(payload.tax),
      shipping: shopifySafeNumber(payload.shipping),
      items: payload.items || [],
      user_data: userData
    }
  });
}